var exports = {
  "h": "DesktopNotificationNagbar.module__description___cl95TE",
};

module.exports = exports;
